enum ScreenNamesTypes {
  pre_signup_pricelist = "pre_signup_pricelist",
  setup_store_details = "setup_store_details",
  signup_landing = "signup_landing",
  select_store_format = "select_store_format",
  web_location_check = "web_location_check",
  pin_location = "pin_location",
  input_address_details = "input_address_details",
  setup_store_profile = "setup_store_profile",
  sign_up_otp = "sign_up_otp",
  terms_conditions_confirmation = "terms_conditions_confirmation",
  security_questions = "security_questions",
  onboarding_screen1 = "onboarding_screen1",
  onboarding_screen2 = "onboarding_screen2",
  unserviceable_location = "unserviceable_location",
  unserviceable_walang_negosyo = "unserviceable_walang_negosyo",
  iba_pang_negosyo_survey = "iba_pang_negosyo_survey",
  unserviceable_iba_pang_negosyo = "unserviceable_iba_pang_negosyo",
  web_log_in = "web_log_in",
}

enum ButtonNamesType {
  pricelist_add_to_cart = "pricelist_add_to_cart",
  pricelist_signup = "pricelist_signup",
  pricelist_browsefirst = "pricelist_browsefirst",
  agree_data_and_privacy = "agree_data_and_privacy",
  decline_data_and_privacy = "decline_data_and_privacy",
  create_account = "create_account",
  log_in = "log_in",
  submit_store_details = "submit_store_details",
  web_signup_back = "web_signup_back",
  check_gps_location = "check_gps_location",
  not_in_store = "not_in_store",
  allow_gps_access = "allow_gps_access",
  deny_gps_access = "deny_gps_access",
  skip_store_profile = "skip_store_profile",
  submit_otp = "submit_otp",
  onboarding_screen_cta = "onboarding_screen_cta",
  start_shopping = "start_shopping",
  exit_screen = "exit_screen",
  follow_on_fb = "follow_on_fb",
}

enum PopUpNamesType {
  SignUpPrompt = "SignUpPrompt",
  data_and_privacy = "data_and_privacy",
  access_gps_popup = "access_gps_popup",
}

enum CRMBannerNamesType {
  end_of_pricelist_banner = "end_of_pricelist_banner",
}

export { ScreenNamesTypes, ButtonNamesType, PopUpNamesType, CRMBannerNamesType };
